<app-go-back-and-title titulo="Ver Persona"></app-go-back-and-title>
<ngx-spinner [zIndex]="100" name="spPersona" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>
<div *appRoles="['Personas.Ver']">
  <div *ngIf="personaDetailDto">

    <mat-tab-group>
      <mat-tab label="Persona">
        <div class="container-fluid">
          <br>
          <button mat-stroked-button color="primary" [matMenuTriggerFor]="menu" class="app-button-action"
            matTooltip="Acciones">
            <mat-icon>more_vert</mat-icon> Acciones
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item [routerLink]="['/personas/edit/' + personaDetailDto.id]">
              <mat-icon>edit</mat-icon>Editar
            </button>
            <button mat-menu-item (click)="openDialogDelete(personaDetailDto)">
              <mat-icon>delete</mat-icon>Eliminar
            </button>
          </mat-menu>
          <br><br>
          <div class="row">
            <div class="col">
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Información de Persona</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-name">Nombre:</span>
                    <span class="property-value">{{ personaDetailDto.nombre | uppercase }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Apellido:</span>
                    <span class="property-value">{{ personaDetailDto.apellido | uppercase }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Tipo de Documento:</span>
                    <span class="property-value">{{
                      personaDetailDto.tipoDocumento?.descripcion | uppercase
                      }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Nro. de Documento:</span>
                    <span class="property-value">{{ personaDetailDto.nroDocumento }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Estado Civil:</span>
                    <span class="property-value">{{
                      personaDetailDto.estadoCivil?.descripcion | titlecase
                      }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Fecha Nacimiento:</span>
                    <span class="property-value">{{ personaDetailDto.fechaNacimiento | date : "short" }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col">
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Estado y Otras Informaciones</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-name">Estado:</span>
                    <app-status-badge [estado]=" personaDetailDto.activo "></app-status-badge>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Fecha Alta:</span>
                    <span class="property-value">{{ personaDetailDto.fechaAlta | date }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Ultima Modificación:</span>
                    <span class="property-value">{{ personaDetailDto.fechaModificacion | date }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Observaciones:</span>
                    <span class="property-value"> {{ personaDetailDto.observacion }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col">
              <app-card-view-contactos-simple [contactos]="contactos" ></app-card-view-contactos-simple>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Contactos">
        <div class="container-fluid">
          <br>
          <app-list-contacto (contactosLoad)="onContactosActualizados($event)" [idPersona]="idPersona"></app-list-contacto>
          <!-- <app-list-contacto [idPersona]="personaDetailDto.id"></app-list-contacto> -->
        </div>
      </mat-tab>
      <mat-tab label="Expedientes">
        <div class="container-fluid">
          <br>
          <app-list-expediente [idPersona]="idPersona"></app-list-expediente>
        </div>
      </mat-tab>
      <mat-tab label="Documentos" *appRoles="['Documentos.Listar']">
        <div class="container-fluid">
          <br>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
